import { Controller } from "stimulus";
import { useIntersection } from "stimulus-use";

export default class extends Controller {
  connect() {
    useIntersection(this, {
      // rootMargin: "100px",
    });
  }

  appear(event) {
    this.loadMore(this.nextUrl);
  }

  loadMore(url) {
    fetch(url)
      .then(response => response.text())
      .then(html => {
        this.element.outerHTML = html;
      })
  }

  get nextUrl() {
    return this.data.get("nextUrl");
  }
}
